import flyoutProfiles from './flyout-profiles';

export default function () {
  const mobileMenuOpenBtn = document.querySelector('.header__burger--open');
  const mobileMenuCloseBtn = document.querySelector('.header__burger--close');
  const mobileMenu = document.querySelector('.header__mobile');
  const accordions = document.querySelectorAll('[data-toggle="accordion"]');
  const header = document.querySelector('.header');
  const heroComponent = document.querySelector('.hero');
  const subMenuRoot = document.querySelector('.header__sub-menu-root');
  const headerExploreBtnClass = '.header__explore';
  const breakpointMd = 768;
  let lastScroll = 0;
  let currentScroll = 0;
  const scrollThreshold = 100;
  const fixedEnterThreshold = scrollThreshold + 20;
  const fixedExitThreshold = scrollThreshold + 400;
  let isFixed = false;
  let ticking = false;
  let scrollStopTimer = null;

  function initializeHeader() {
    if (!header) return;

    if (!heroComponent) {
      const wpadminbar = document.getElementById('wpadminbar');
      document.body.classList.add('no-hero');
      header.classList.add('header--styled');

      const heightWpadminbar = wpadminbar ? wpadminbar.offsetHeight : 0;
      const headerHeight = header.offsetHeight + heightWpadminbar + 1;
      document.body.style.paddingTop = `${headerHeight}px`;
    }

    lastScroll = window.scrollY;

    // Keep hidden mobile navigation out of the tab order.
    // `inert` prevents focus/interaction, `aria-hidden` exposes state to AT.
    // eslint-disable-next-line no-use-before-define
    updateMobileMenuAccessibility();
  }

  function updateMobileMenuAccessibility() {
    if (!mobileMenu) return;

    const isOpen = mobileMenu.classList.contains('open');
    mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

    if (isOpen) {
      mobileMenu.removeAttribute('inert');
    } else {
      mobileMenu.setAttribute('inert', '');
    }
  }

  function handleScroll() {
    if (!ticking) {
      // eslint-disable-next-line no-use-before-define
      requestAnimationFrame(() => updateHeader());
      ticking = true;
    }
  }

  function updateHeader() {
    if (scrollStopTimer) {
      clearTimeout(scrollStopTimer);
    }

    currentScroll = Math.max(0, window.scrollY);

    const isSubmenuOpen = !!(subMenuRoot && subMenuRoot.classList.contains('is-visible'));

    if (currentScroll <= fixedExitThreshold && !isSubmenuOpen) {
      // eslint-disable-next-line no-use-before-define
      returnToAbsolute();
    } else {
      // eslint-disable-next-line no-use-before-define
      handleFixedBehavior();
    }

    lastScroll = currentScroll;
    ticking = false;

    scrollStopTimer = setTimeout(() => {
      if (
        header
        && header.classList.contains('header--fixed')
        && !header.classList.contains('header--visible')
      ) {
        // eslint-disable-next-line no-use-before-define
        showHeader();
      }
    }, 1500);
  }

  function returnToAbsolute() {
    if (isFixed) {
      // eslint-disable-next-line no-use-before-define
      hideRootSubmenu();
      const isScrollingUp = currentScroll < lastScroll;
      if (isScrollingUp) {
        requestAnimationFrame(() => {
          header.classList.remove('header--fixed');
        });
        isFixed = false;
      } else {
        requestAnimationFrame(() => {
          header.classList.remove('header--visible');
        });
        setTimeout(() => {
          header.classList.remove('header--fixed');
          isFixed = false;
        }, 500);
      }
    }
  }

  function handleFixedBehavior() {
    const flyoutMenu = document.getElementById('flyout-profile-menu');
    const isFlyoutOpen = flyoutMenu && flyoutMenu.classList.contains('flyout-profile--open');

    const shouldBeFixed = currentScroll >= fixedEnterThreshold || isFlyoutOpen;
    if (!isFixed && shouldBeFixed) {
      // eslint-disable-next-line no-use-before-define
      switchToFixed();
    }

    const isScrollingUp = currentScroll < lastScroll;
    const scrollDelta = Math.abs(currentScroll - lastScroll);
    const isCoarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    const minDelta = isCoarsePointer ? 8 : 3;

    if (scrollDelta > minDelta) {
      if (isScrollingUp) {
        // eslint-disable-next-line no-use-before-define
        showHeader();
      } else {
        // eslint-disable-next-line no-use-before-define
        hideRootSubmenu();
        requestAnimationFrame(() => {
          // eslint-disable-next-line no-use-before-define
          hideHeader();
        });
      }
    }
  }

  function switchToFixed() {
    requestAnimationFrame(() => {
      header.classList.add('header--fixed');
    });

    isFixed = true;

    const isScrollingUp = currentScroll < lastScroll;
    if (isScrollingUp) {
      setTimeout(() => {
        // eslint-disable-next-line no-use-before-define
        showHeader();
      }, 50);
    }
  }

  function showHeader() {
    header.classList.add('header--visible');
  }

  function hideHeader() {
    const flyoutMenu = document.getElementById('flyout-profile-menu');
    const isFlyoutOpen = flyoutMenu && flyoutMenu.classList.contains('flyout-profile--open');
    if (isFlyoutOpen) return;
    header.classList.remove('header--visible');
  }

  function handleResize() {
    if (window.innerWidth > breakpointMd) {
      mobileMenu.classList.remove('open');
    }

    updateMobileMenuAccessibility();

    if (!heroComponent && header) {
      const wpadminbar = document.getElementById('wpadminbar');
      const heightWpadminbar = wpadminbar ? wpadminbar.offsetHeight : 0;
      const headerHeight = header.offsetHeight + heightWpadminbar + 1;
      document.body.style.paddingTop = `${headerHeight}px`;
    }

    lastScroll = window.scrollY;
  }

  const menuItems = document.querySelectorAll('.header__item');

  let currentOpenLink = null;
  let hideGlobalTimer = null;

  function focusFirstSubItem() {
    if (!subMenuRoot) return;
    const firstSubItem = subMenuRoot.querySelector('a, button, [tabindex="0"]');
    firstSubItem?.focus();
  }

  function focusAfterDesktopMainNav() {
    const langControl = document.querySelector(
      '.header__language--desktop .c-custom-select--language',
    );
    if (langControl) {
      langControl.focus();
      return;
    }
    document.querySelector('.header__cta')?.focus();
  }

  function focusNextMainLink() {
    if (!currentOpenLink) return;
    const currentItem = currentOpenLink.closest('.header__item');
    if (!currentItem) return;
    let nextItem = currentItem.nextElementSibling;
    while (nextItem && !nextItem.matches('.header__item')) {
      nextItem = nextItem.nextElementSibling;
    }

    const nextLink = nextItem ? nextItem.querySelector('.header__link') : null;

    // eslint-disable-next-line no-use-before-define
    hideRootSubmenu();
    if (nextLink) {
      nextLink.focus();
    } else {
      focusAfterDesktopMainNav();
    }
  }

  function transferSubMenu(item) {
    if (!subMenuRoot || !item) return;
    subMenuRoot.innerHTML = item.innerHTML;
  }

  function showRootSubmenu(link, submenu) {
    transferSubMenu(submenu);
    if (currentOpenLink && currentOpenLink !== link) {
      currentOpenLink.classList.remove('is-open');
    }
    link.classList.add('is-open');
    header.classList.add('header--submenu-open');

    if (!isFixed && currentScroll >= fixedEnterThreshold) {
      // eslint-disable-next-line no-use-before-define
      switchToFixed();
      // eslint-disable-next-line no-use-before-define
      showHeader();
    }
    // restart animation if already visible
    if (subMenuRoot.classList.contains('is-visible')) {
      subMenuRoot.classList.remove('is-visible');
      // eslint-disable-next-line no-unused-expressions
      subMenuRoot.offsetWidth;
      requestAnimationFrame(() => {
        subMenuRoot.classList.add('is-visible');
      });
    } else {
      subMenuRoot.classList.add('is-visible');
    }
    currentOpenLink = link;
  }

  function hideRootSubmenu() {
    subMenuRoot.classList.remove('is-visible');
    if (currentOpenLink) {
      currentOpenLink.classList.remove('is-open');
      currentOpenLink = null;
    }

    const flyoutMenu = document.getElementById('flyout-profile-menu');
    const isFlyoutOpen = flyoutMenu && flyoutMenu.classList.contains('flyout-profile--open');

    if (!isFlyoutOpen) {
      header.classList.remove('header--submenu-open');
    }

    if (currentScroll <= fixedExitThreshold && isFixed && !isFlyoutOpen) {
      requestAnimationFrame(() => {
        header.classList.remove('header--visible');
      });
      setTimeout(() => {
        header.classList.remove('header--fixed');
        isFixed = false;
      }, 500);
    }
  }

  menuItems.forEach((item) => {
    const link = item.querySelector('.header__link');
    const submenu = item.querySelector('.header__sub');
    let showTimer;
    let hideTimer;

    if (submenu) {
      item.addEventListener('mouseenter', () => {
        clearTimeout(hideGlobalTimer);
        clearTimeout(hideTimer);
        showTimer = setTimeout(() => {
          showRootSubmenu(link, submenu);
        }, 0);
      });

      item.addEventListener('mouseleave', () => {
        clearTimeout(showTimer);
        hideGlobalTimer = setTimeout(() => {
          const headerHovered = header.matches(':hover');
          const submenuHovered = subMenuRoot && subMenuRoot.matches(':hover');
          const submenuHasFocus = subMenuRoot && subMenuRoot.matches(':focus-within');
          if (headerHovered || submenuHovered || submenuHasFocus) return;
          hideRootSubmenu();
        }, 120);
      });

      link.addEventListener('focus', () => {
        clearTimeout(hideGlobalTimer);
        showTimer = setTimeout(() => {
          showRootSubmenu(link, submenu);
        }, 0);
      });

      link.addEventListener('focusout', (e) => {
        clearTimeout(showTimer);
        hideGlobalTimer = setTimeout(() => {
          const related = e.relatedTarget;
          const movedIntoSubmenu = related && subMenuRoot && subMenuRoot.contains(related);
          if (header.matches(':focus-within') || movedIntoSubmenu) return;
          hideRootSubmenu();
        }, 120);
      });

      submenu.addEventListener('focusin', () => {
        clearTimeout(hideTimer);
      });

      submenu.addEventListener('focusout', (e) => {
        if (!submenu.contains(e.relatedTarget)) {
          hideGlobalTimer = setTimeout(() => {
            hideRootSubmenu();
          }, 120);
        }
      });

      link.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey)) {
          const isOpen = subMenuRoot.classList.contains('is-visible');
          if (isOpen) {
            e.preventDefault();
            focusFirstSubItem();
            return;
          }
          e.preventDefault();
          showRootSubmenu(link, submenu);
          focusFirstSubItem();
        }
      });
    } else {
      item?.addEventListener('mouseenter', () => {
        clearTimeout(hideGlobalTimer);
        subMenuRoot?.classList.remove('is-visible');
        currentOpenLink?.classList.remove('is-open');
      });

      link?.addEventListener('focus', () => {
        clearTimeout(hideGlobalTimer);
        subMenuRoot?.classList.remove('is-visible');
        currentOpenLink?.classList.remove('is-open');
      });
    }
  });

  if (subMenuRoot) {
    subMenuRoot.addEventListener('mouseenter', () => {
      clearTimeout(hideGlobalTimer);
    });

    subMenuRoot.addEventListener('mouseleave', () => {
      hideGlobalTimer = setTimeout(() => {
        const headerHovered = header.matches(':hover');
        const submenuHovered = subMenuRoot.matches(':hover');
        const submenuHasFocus = subMenuRoot.matches(':focus-within');
        if (headerHovered || submenuHovered || submenuHasFocus) return;
        hideRootSubmenu();
      }, 120);
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.header') && !e.target.closest('.header__sub-menu-root')) {
        hideRootSubmenu();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') hideRootSubmenu();
    });

    subMenuRoot.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;

      const focusables = subMenuRoot.querySelectorAll('a, button, [tabindex="0"]');
      if (focusables.length === 0) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;

      if (!e.shiftKey && active === last) {
        e.preventDefault();
        focusNextMainLink();
      } else if (e.shiftKey && active === first) {
        e.preventDefault();
        if (currentOpenLink) currentOpenLink.focus();
      }
    });
  }

  mobileMenuOpenBtn?.addEventListener('click', () => {
    mobileMenu?.classList.add('open');
    updateMobileMenuAccessibility();
  });

  mobileMenuCloseBtn?.addEventListener('click', () => {
    mobileMenu?.classList.remove('open');
    updateMobileMenuAccessibility();
  });

  accordions.forEach((button) => {
    button.addEventListener('click', () => {
      const isAlreadyOpen = button.classList.contains('is-open');
      const content = button.nextElementSibling;
      const exploreBtn = content?.querySelector(headerExploreBtnClass);

      if (isAlreadyOpen) {
        button.classList.remove('is-open');
        content?.classList.remove('is-visible');
        exploreBtn?.classList.remove('active');
      } else {
        accordions.forEach((btn) => {
          const btnContent = btn.nextElementSibling;
          const btnExplore = btnContent?.querySelector(headerExploreBtnClass);

          if (btn !== button) {
            btn.classList.remove('is-open');
            btnContent?.classList.remove('is-visible');
            btnExplore?.classList.remove('active');
          }
        });

        setTimeout(() => {
          button.classList.add('is-open');
          content?.classList.add('is-visible');
          exploreBtn?.classList.add('active');
        }, 300);
      }
    });
  });

  initializeHeader();

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', handleResize);

  const hideFullCard = document.querySelector('.js_user-flyout__back-link');
  const showFullCard = document.querySelector('.js_user-flyout__card-link');
  const fullCard = document.querySelector('.user-flyout');

  showFullCard?.addEventListener('click', (e) => {
    fullCard?.classList.add('open');
    e.preventDefault();
  });
  hideFullCard?.addEventListener('click', (e) => {
    fullCard?.classList.remove('open');
    e.preventDefault();
  });
}

window.document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line new-cap
  const flyout = new flyoutProfiles();

  let hashFromClasslessAnchor = null;

  document.addEventListener('click', (e) => {
    const link = e.target.closest('a');
    if (!link || !link.getAttribute('href')?.includes('#')) {
      return;
    }
    const className = link.getAttribute('class');
    if (className != null && className.trim() !== '') {
      return;
    }
    const idx = link.href.indexOf('#');
    hashFromClasslessAnchor = idx === -1 ? '' : link.href.slice(idx);
  }, true);

  function handleHash(hash) {
    if (!hash) return;

    if (window.isRegistrationComplete === false) {
      if (window.history && window.history.pushState) {
        window.history.pushState('', document.title, window.location.pathname + window.location.search);
      }
      return;
    }

    const parts = hash.split('#').filter((part) => part !== '');
    const flyoutHash = `#${parts[0]}`;
    const elementHash = parts[1] ? `#${parts[1]}` : null;

    const block = document.querySelector(flyoutHash);
    if (block && block.classList.contains('flyout-profile')) {
      flyout.openBlock(block);

      if (elementHash) {
        setTimeout(() => {
          const targetElement = block.querySelector(elementHash);
          if (targetElement) {
            targetElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }, 300);
      }
    }
  }

  function onHashChange(callback) {
    window.addEventListener('hashchange', () => {
      callback(window.location.hash);
    });
  }

  onHashChange((hash) => {
    if (!hash) {
      hashFromClasslessAnchor = null;
      return;
    }

    if (hashFromClasslessAnchor === hash) {
      hashFromClasslessAnchor = null;
      return;
    }
    hashFromClasslessAnchor = null;

    handleHash(hash);
  });

  const activeEl = document.querySelector('.my-account__nav-list .active');
  if (activeEl) {
    activeEl.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest',
    });
  }

  /**
   * On the sign-in page: if the browser preserved a hash fragment from the
   * original protected-page redirect, append it to the return_url inside
   * every Azure B2C login link's `state` parameter so that after a successful
   * login the user lands back on the correct page with the flyout open.
   */
  function updateB2cLinksWithHash() {
    const locationHref = new URL(window.location.href);
    const { hash } = locationHref;

    if (!hash) return;

    const urlParams = new URLSearchParams(window.location.search);
    const returnTo = urlParams.get('return_to');
    if (!returnTo || returnTo.includes('#')) return;

    const fullReturnUrl = returnTo + hash;
    let lang;
    try {
      const firstB2cLink = document.querySelector('a[href*="b2clogin.com"]');
      if (firstB2cLink) {
        const existingState = new URL(firstB2cLink.href).searchParams.get('state');
        if (existingState) {
          lang = JSON.parse(existingState).lang;
        }
      }
    } catch (e) {
      // ignore malformed existing state
    }

    const newState = { return_url: fullReturnUrl };
    if (typeof lang === 'string' && lang !== '') {
      newState.lang = lang;
    }

    document.querySelectorAll('a[href*="b2clogin.com"]').forEach((link) => {
      try {
        const url = new URL(link.href);
        url.searchParams.delete('state');
        url.searchParams.set('state', JSON.stringify(newState));
        // eslint-disable-next-line no-param-reassign
        link.href = url.toString();
      } catch (e) {
        // skip malformed URLs
      }
    });
  }

  updateB2cLinksWithHash();

  const userNotification = document.querySelector('.js-flyout-notification');
  const locationHref = new URL(window.location.href);
  const flyoutHash = locationHref.hash;

  if (userNotification) {
    window.location.hash = 'flyout-profile-menu';
  } else if (flyoutHash === '#flyout-profile-menu' && !document.body.classList.contains('logged-in')) {
    const loginLink = document.querySelector('.header__login');
    if (loginLink && loginLink.href && loginLink.href.indexOf('#') === -1) {
      const url = new URL(loginLink.href);
      const currentLang = document.documentElement.lang;
      const lang = currentLang !== 'en-US' ? `/${currentLang}` : '';
      const fullReturnUrl = `${window.location.origin}${lang}/${flyoutHash}`;
      url.searchParams.set('return_to', fullReturnUrl);
      window.location.href = url.toString();
    }
  } else if (window.location.hash) {
    handleHash(window.location.hash);
  }
});
